import styled from 'styled-components';

const ReviewFooterWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export { ReviewFooterWrapper };
